import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GuideCapture = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("sending");
    try {
      const res = await fetch(`${API}/guide-leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (!res.ok) throw new Error();
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <div className="rounded-2xl border border-gold-500/35 bg-cream-100 p-8 sm:p-10" data-testid="guide-capture-card">
      {state === "done" ? (
        <div className="text-center">
          <p className="eyebrow mb-4">On Its Way</p>
          <p className="font-serif text-2xl sm:text-3xl text-forest-800" data-testid="guide-success-message">
            Check your inbox — your guide is on its way.
          </p>
          <Link
            to="/intensive-guide"
            data-testid="guide-read-link"
            className="inline-flex items-center gap-2 mt-6 rounded-full bg-forest-500 text-cream-50 font-semibold text-sm px-7 py-3.5 transition-colors duration-300 hover:bg-forest-700"
          >
            Read the guide now <ArrowRight size={15} />
          </Link>
        </div>
      ) : (
        <div>
          <p className="eyebrow mb-4">Not Sure Yet?</p>
          <p className="font-serif text-2xl sm:text-3xl text-forest-800 leading-snug max-w-lg">
            Is an Intensive right for us? — a one-page guide
          </p>
          <p className="mt-3 text-sm text-sage leading-relaxed max-w-xl">
            Five honest questions to help you decide, plus what an intensive is — and isn't. Leave your email and
            I'll send it over; you can also read it right away.
          </p>
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3" data-testid="guide-capture-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              data-testid="guide-email-input"
              className="flex-1 rounded-full border border-forest-800/15 bg-cream-50 px-5 py-3.5 text-sm text-ink placeholder:text-sage/60 focus:outline-none focus:border-gold-500/60"
            />
            <button
              type="submit"
              disabled={state === "sending"}
              data-testid="guide-submit-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-forest-500 text-cream-50 font-semibold text-sm px-7 py-3.5 transition-colors duration-300 hover:bg-forest-700 disabled:opacity-60"
            >
              {state === "sending" ? "Sending…" : "Send Me the Guide"} <ArrowRight size={15} />
            </button>
          </form>
          {state === "error" && (
            <p className="mt-3 text-sm text-red-700" data-testid="guide-error-message">
              Something went wrong — please try again in a moment.
            </p>
          )}
          <p className="mt-4 text-xs text-sage/70" data-testid="guide-privacy-note">
            Your email is used only to send the guide. No newsletters, no pressure.
          </p>
        </div>
      )}
    </div>
  );
};

export default GuideCapture;
